import Index from "container/about-us/about-us.container";
import { useTranslation } from "next-i18next";
import Head from "next/head";

function AboutUs(props) {
  const { t } = useTranslation("static-pages");

  return (
    <>
      <Head>
        <title>{t("About Parts Avatar")}</title>
        <script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async />
      </Head>
      <Index {...props} />
    </>
  );
}

export default AboutUs;
